import { API_URL } from "../shared/config";

export const getImage=(url)=>{
    if (url?.includes('http')) return url;
    return `${API_URL}${url}`
}